import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import windowSize from "../libs/reactWindowSize";
import uuid from "uuid/v4";
import { withScenePosition } from "../scenePosition";
import {Link} from "react-router-dom";
import { Translate } from 'react-localize-redux';

class MiniTour extends Component {

  constructor(props){
    super(props);

    this.state = {
      id:  props.id || uuid()
    };

    this.containerRef = React.createRef();

    this.nextMinitour = this.nextMinitour.bind(this);
    this.backMinitour = this.backMinitour.bind(this);
  }

  static getDerivedStateFromProps(props, state){
    let { title, paragraph, level, minitourState } = props;

    return {
      ...state,
      title: title,
      paragraph: paragraph,
      showIntro: minitourState.showIntro,
      level: level,
      components: props.components
    }
  }

  startMinitour(){
    let { dispatch } = this.props;
    dispatch({
      type: "minitour/START",
      payload: this.props.id
    });
    dispatch({
      type: "step/OVERRIDE_TOP",
      payload: this.props.id
    });
  }

  nextMinitour(){
    let { dispatch } = this.props;
    dispatch({
      type: "minitour/NEXT",
      payload: this.props.id
    });
  }

  backMinitour(){
    let { dispatch } = this.props;
    dispatch({
      type: "minitour/BACK"
    });
    dispatch({
      type: "step/FINISH"
    });
  }



  render() {
    const { id, showIntro } = this.state;
    const { title, paragraph, paragraphExtra, paragraphLink, paragraphLinkLabel, externalLink, externalLinkLabel, left, top, width, height, minitourState, location } = this.props;

    let hideTop, shiftedTop;
    if (!this.containerRef.current) {
      hideTop = true;
      shiftedTop = top;
    }
    else {
      shiftedTop = !!showIntro ? top : (parseInt(top, 10) - this.containerRef.current.clientHeight) + "px";
    }


    return (
      <div className={`hotspot-wrapper active-minitour`} >
        <button className="minitour-button previous-button" onClick={this.backMinitour}><i className="fa fa-angle-left" aria-hidden="true"></i><span><Translate id="miniTourPreviousScreen"/></span><i className="fa fa-angle-right" aria-hidden="true"></i></button>

        {id === minitourState.minitourId &&
          <div className={`minitour-container ${hideTop ? 'collapsed' : ''}`} ref={this.containerRef} style={{top: shiftedTop, left: left, width: width, height: height}}>
            {!hideTop &&
              <Fragment>
                <h2><Translate id={title}/></h2>
                <p>

                  <span><Translate id={paragraph}/></span>
                  {!!paragraphLink &&
                    <Link to={{ pathname: paragraphLink, search: location.search }}><em><Translate id={paragraphLinkLabel}/></em></Link>
                  }
                  <span>{paragraphExtra ? <Translate id={paragraphExtra}/> : undefined}</span>
                </p>
                {!!externalLink &&
                  <div><a className="tooltip-text-link" href={externalLink + window.location.search} target="_blank" ><Translate id={externalLinkLabel}/> <i className="fa fa-external-link" aria-hidden="true"></i></a></div>
                }
                <div className="button-wrapper">
                  <button className="minitour-button fill-next-button" onClick={this.nextMinitour}><Translate id="miniTourGotIt"/></button>
                </div>
              </Fragment>
            }
          </div>
        }

        {!!showIntro &&
          <div className="minitour-backdrop"></div>
        }

        {this.props.children}
      </div>
    );
  }

}

MiniTour.propTypes = {
  title: PropTypes.string,
  paragraph: PropTypes.string,
  paragraphExtra: PropTypes.string,
  paragraphLink: PropTypes.string,
  paragraphLinkLabel: PropTypes.string,
  externalLink: PropTypes.string,
  externalLinkLabel: PropTypes.string
};

MiniTour.defaultProps = {
  title: "",
  paragraph: "",
  paragraphExtra: "",
  paragraphLink: null,
  paragraphLinkLabel: "",
  externalLink: null,
  externalLinkLabel: ""
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    minitourState: state.minitour
  }
}

export default windowSize(connect(mapStateToProps)(withScenePosition(MiniTour)));



// WEBPACK FOOTER //
// ./src/components/MiniTour.jsx